// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const { version }: { version: string } = require('../../package.json');
export const environment = {
  production: false,
  version: version,
  XSRF_TOKEN_NAME: '_xsrf',
  AUTH_TOKEN: 'auth',
  EXPIRY_DATE: 'expiry',
  REFRESH_TOKEN: 'refresh',
  USER: 'user',
  PERIMETER: 'perimeter',
  ACCESS_MODE: 'access_mode',
  UPLOAD_MAX_FILESIZE: 1200000,
  api: {
    addressHistories: '/api/address-histories',
    agendaEvents: '/api/agenda-events',
    alerts: '/api/alerts',
    app: '/api/app',
    applicationConfiguration: '/api/application-configuration',
    areas: '/api/areas',
    assessments: '/api/assessments',
    assets: '/api/assets',
    auth: '/api/auth',
    barriers: '/api/barriers',
    beneficiaries: '/api/beneficiaries',
    businessObject: '/api/business-object',
    clearances: '/api/clearances',
    communityAction: '/api/community-action',
    complements: '/api/complements',
    contracts: '/api/contracts',
    customQueries: '/api/custom-queries',
    degrees: '/api/degrees',
    documents: '/api/documents',
    documentTitles: '/api/document-titles',
    employmentBarriers: '/api/employment-barrier',
    employmentJob: '/api/employment-job',
    employmentQualifications: '/api/employment-qualification',
    employments: '/api/employments',
    employmentTransport: '/api/employment-transport-mode',
    healthInsurances: '/api/health-insurances',
    home: 'api/home',
    import: '/api/import',
    inbox: '/api/inbox',
    instructionRsj: '/api/instructions-rsj',
    intensity: '/api/intensity',
    interviews: '/api/interviews',
    interviewThemes: '/api/interview-themes',
    jobs: '/api/jobs',
    jobTypes: '/api/job-types',
    links: '/api/links',
    mail: '/api/mail',
    merge: '/api/fusion',
    naturesTypes: '/api/stage-natures-types',
    orientationHistories: '/api/orientation-histories',
    paymentRsj: '/api/payment-rsj',
    performanceMonitor: '/api/monitor',
    postalAddress: '/api/postal-address',
    profile: '/api/profile',
    qpvs: '/api/qpvs',
    qualificationTypes: '/api/qualification-types',
    queries: '/api/queries',
    referentHistories: '/api/referent-histories',
    rsj: '/api/rsj',
    sectors: '/api/sectors',
    sms: '/api/sms',
    stages: '/api/stages',
    stats: '/api/stats',
    structures: '/api/structures',
    supportHistories: '/api/support-histories',
    supportStatusTypes: '/api/support-status-type',
    supportTypes: '/api/support-types',
    surveysFSE: '/api/surveys-fse',
    towns: '/api/towns',
    trainingAreas: '/api/training-areas',
    transportModes: '/api/transport-modes',
    userAddress: '/api/user-address',
    userList: '/api/users',
    userNotifications: '/api/user-notifications',
    version: '',
  },
  addressesApi: 'https://api-adresse.data.gouv.fr/search/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
